module.exports = __webpack_public_path__ + "img/giftcard_used.4c52eeee.svg";